import CookieButton from "@/shared/ui/buttons/CookieButton";
import Typography from "@/shared/ui/Typography";
import { Link } from "react-router-dom";

type CookieBunnerProps = {
    visible?: boolean;
    handleAccept?: () => void;
};

export const CookieBanner = ({ visible, handleAccept }: CookieBunnerProps) => {
    if (!visible) return null;

    return (
        <div className="w-full rounded-b-[10px] bg-main-grey">
            <div className="container flex flex-row items-center py-[10px] gap-[10px]">
                <Typography className="text-[8px] md:text-[8px] font-[300] !leading-[130%]">
                    Мы используем файлы соокіе. Продолжая работу с сайтом, вы
                    подтверждаете, что полностью ознакомились и согласны с
                    условиями обработки файлов Cookie, изложенных в
                    <Link to="/privacy-policy" className="text-[#116ACC]">
                        {
                            " Политике обработки персональных данных и файлов Cookie."
                        }
                    </Link>
                </Typography>
                <CookieButton onClick={handleAccept}>
                    Хорошо
                </CookieButton>
            </div>
        </div>
    );
};
